// extracted by mini-css-extract-plugin
export default {"incidentCard":"incidentCard_incidentCard__IWQGX","incidentImage":"incidentCard_incidentImage__3FDX9","votes":"incidentCard_votes__BqAFF"};